export const convertLocationToPosition =(location)=>location?`${location?.position?.lat},${location?.position?.lng}`:''